import { render, staticRenderFns } from "./OverlayScopes.vue?vue&type=template&id=775bf830"
import script from "./OverlayScopes.vue?vue&type=script&lang=js"
export * from "./OverlayScopes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports